import React from 'react';
import type { BuyerReview } from '../data/buyerReviews';
const laneColors = ['bg-mint', 'bg-amber', 'bg-coral'];
type ReviewAvatarProps = {
  review: BuyerReview;
  index: number;
  className?: string;
  textClassName?: string;
};

/** Buyer photo when provided; otherwise initials on a lane color. */
export function ReviewAvatar({
  review,
  index,
  className = 'h-12 w-12',
  textClassName = 'text-sm'
}: ReviewAvatarProps) {
  if (review.photo) {
    return <img src={review.photo} alt="" className={`flex-none rounded-full object-cover ${className}`} data-id="element-379" data-mp="24n8s0iop4y0x" />;
  }
  const initials = review.name.split(' ').map(part => part[0]).slice(0, 2).join('');
  return <span aria-hidden="true" className={`flex flex-none items-center justify-center rounded-full font-display font-bold text-rink-deep ${laneColors[index % laneColors.length]} ${className} ${textClassName}`} data-id="element-380" data-mp="2if56hjxfz9eu">
      {initials}
    </span>;
}